import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "aos/dist/aos.css";
import reportWebVitals from "./reportWebVitals";
import AOS from "aos";
import * as firebase from "firebase/app";
import { firebaseConfig } from "./firebase.config";
import "rc-banner-anim/assets/index.css";

AOS.init();

firebase?.initializeApp(firebaseConfig);
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
